module.exports = __webpack_public_path__ + "img/arrow_gray.0dd37509.svg";